import { DeclareAndSubmitApplicationModel } from '../../api/models';
import { VisibilityFunctions } from '../types';
import { showAsicWarning, showAnzsicWarning, showSubsidiaryWarning, showIncomePeriodWarning } from './rndSubmit';
import { showDeclarantTitleOther } from './rndDeclaration';

const showAcknowledgedBy = (values: DeclareAndSubmitApplicationModel) => {
    return showAsicWarning(values) || showSubsidiaryWarning(values) || showAnzsicWarning(values);
};

const showIfDeclarantNotTheSameAsPrimaryCompanyContact = (values: DeclareAndSubmitApplicationModel) => {
    return values.isDeclarantSameAsPrimaryCompanyContact === 'No';
};

const showIfDeclarantTheSameAsPrimaryCompanyContact = (values: DeclareAndSubmitApplicationModel) => {
    return values.isDeclarantSameAsPrimaryCompanyContact === 'Yes';
};

export const pdfDeclarationAndSubmission: VisibilityFunctions<DeclareAndSubmitApplicationModel> = {
    asicWarningAcknowledged: showAsicWarning,
    subsidiaryWarningAcknowledged: showSubsidiaryWarning,
    incomePeriodWarningAcknowledged: showIncomePeriodWarning,
    anzsicWarningAcknowledged: showAnzsicWarning,
    titleOther: showDeclarantTitleOther,
    acknowledgerName: showAcknowledgedBy,
    acknowledgerEmployerAbn: showAcknowledgedBy,
    declarantRelationshipWithCompany: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
    primaryCompanyContact: showIfDeclarantTheSameAsPrimaryCompanyContact,
    title: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
    firstName: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
    lastName: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
    position: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
    phone: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
    email: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
    entityDetails: showIfDeclarantNotTheSameAsPrimaryCompanyContact,
};
